import React from 'react';

interface RemovePasskeysModalContentProps {
    header: string;
    description: string;
}

const RemovePasskeyModalContent = (props: RemovePasskeysModalContentProps) => {
    const { header, description } = props;

    return (
        <>
            <h2
                className="remove-passkey-modal__header"
                data-testid="remove-passkey-modal-header"
            >
                {header}
            </h2>
            <p
                className="remove-passkey-modal__body-text"
                data-testid="remove-passkey-modal-body-text"
            >
                {description}
            </p>
        </>
    );
};

export default RemovePasskeyModalContent;
